// todo common ui file

export const FORM_NAME = 'FORM_NAME';
